import { FALLBACK_IMAGE_URL } from '../../../shared/config'
import { isVideoUrl, handleImageError } from '../../../shared/lib'

interface ChurchMediaProps {
  mediaUrl: string
  churchName: string
  className?: string
  onLoad?: () => void
}

export const ChurchMedia = ({ mediaUrl, churchName, className, onLoad }: ChurchMediaProps) => {
  if (isVideoUrl(mediaUrl)) {
    return (
      <video
        src={mediaUrl}
        autoPlay
        loop
        muted
        playsInline
        className={className}
        onLoadedData={onLoad}
        onError={(e) => {
          onLoad?.()
          const videoElement = e.target as HTMLVideoElement
          const fallbackImg = document.createElement('img')
          fallbackImg.alt = `${churchName}성전 청년봉사선교회`
          fallbackImg.className = className || ''
          fallbackImg.onerror = (ev) => {
            if (ev instanceof Event) handleImageError(ev)
          }
          fallbackImg.src = FALLBACK_IMAGE_URL
          videoElement.parentNode?.replaceChild(fallbackImg, videoElement)
        }}
      />
    )
  }

  return (
    <img
      src={mediaUrl}
      alt={`${churchName}성전 청년봉사선교회`}
      className={className}
      onLoad={onLoad}
      onError={(e) => {
        onLoad?.()
        handleImageError(e)
      }}
    />
  )
}
